export default "__VITE_ASSET__db07173e__"